'use client'
import { ChatBubbleLeftRightIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline'
import { cn } from '@tebuto/lib/utils'
import type { JSX } from 'react'
import ContactForm from '../ContactForm'

export default function Contact({
    className = '',
    isPageTitle
}: {
    className?: string
    isPageTitle?: boolean
}): JSX.Element {
    return (
        <div className={cn('relative isolate bg-white z-0', className)}>
            <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 mb-10">
                <div className="relative px-6 pb-20 lg:static lg:px-8 lg:py-48 py-20">
                    <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
                        <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-primary-100 ring-1 ring-primary-900/10 lg:w-1/2">
                            <svg
                                className="absolute inset-0 h-full w-full stroke-primary-200 mask-[radial-gradient(100%_100%_at_top_right,white,transparent)]"
                                aria-hidden="true"
                            >
                                <defs>
                                    <pattern
                                        id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                                        width={200}
                                        height={200}
                                        x="100%"
                                        y={-1}
                                        patternUnits="userSpaceOnUse"
                                    >
                                        <path d="M130 200V.5M.5 .5H200" fill="none" />
                                    </pattern>
                                </defs>
                                <rect width="100%" height="100%" strokeWidth={0} fill="white" />
                                <svg x="100%" y={-1} className="overflow-visible fill-primary-50" aria-hidden="true">
                                    <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                                </svg>
                                <rect
                                    width="100%"
                                    height="100%"
                                    strokeWidth={0}
                                    fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                                />
                            </svg>
                        </div>
                        {isPageTitle && (
                            <h1 className="text-3xl font-bold tracking-tight text-primary-900">
                                Nehmen Sie Kontakt mit uns auf
                            </h1>
                        )}
                        {!isPageTitle && (
                            <h2 className="text-3xl font-bold tracking-tight text-primary-900">
                                Nehmen Sie Kontakt mit uns auf
                            </h2>
                        )}
                        <p className="mt-6 text-lg leading-8 text-primary-700">
                            Wir freuen uns auf Ihre Nachricht und melden uns schnellstmöglich bei Ihnen.
                        </p>
                        <dl className="mt-10 space-y-4 text-base leading-7 text-primary-700">
                            <div className="flex gap-x-4">
                                <dt className="flex-none">
                                    <span className="sr-only">Telefon</span>
                                    <PhoneIcon className="size-7 text-primary-700" aria-hidden="true" />
                                </dt>
                                <dd>
                                    <a
                                        className="hover:text-primary-900"
                                        href={`tel:${process.env.NEXT_PUBLIC_SUPPORT_PHONE}`}
                                    >
                                        {process.env.NEXT_PUBLIC_SUPPORT_PHONE}
                                    </a>
                                </dd>
                            </div>
                            <div className="flex gap-x-4">
                                <dt className="flex-none">
                                    <span className="sr-only">E-Mail</span>
                                    <EnvelopeIcon className="size-7 text-primary-700" aria-hidden="true" />
                                </dt>
                                <dd>
                                    <a
                                        className="hover:text-primary-900"
                                        href={`mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}`}
                                    >
                                        {process.env.NEXT_PUBLIC_SUPPORT_EMAIL}
                                    </a>
                                </dd>
                            </div>
                            <div className="flex gap-x-4">
                                <dt className="flex-none">
                                    <span className="sr-only">E-Mail</span>
                                    <ChatBubbleLeftRightIcon className="size-7 text-primary-700" aria-hidden="true" />
                                </dt>
                                <dd>
                                    <a
                                        className="hover:text-primary-900"
                                        href={'https://wa.me/+4972146712023'}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        WhatsApp Nachricht schreiben
                                    </a>
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <div className="flex items-center mb-20 px-6">
                    <ContactForm />
                </div>
            </div>
        </div>
    )
}
